// Портал — хичээлийн хуваарь ("Хичээлийн хуваарь.html"-ийн загвар): сурагч өөрийнхөө, эцэг эх хүүхэд бүрийнхээ.
// Зөвхөн өөрийн бүлэг ба сонгосон сонгон хичээл. Утсанд өдрөөр, том дэлгэцэнд долоо хоногоор.
// Баталгаажсан Passion Program (хичээлийн өмнө/дараа) — хуваарийн доор тусдаа мөрөөр.
import React, { useEffect, useMemo, useState } from "react";
import { Spin } from "antd";
import { instance } from "utils/axios";
import { WeekGrid, DayList, Legend } from "./WeekView";
import { ElementaryWeek, ElementaryDay } from "./ElementaryView";
import { assetUrl } from "pages/Passion/Poster";

const DAY_FULL = ["", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"];

// Баталгаажсан Passion хөтөлбөрүүд: долоо хоногоор — бүгд, өдрөөр — тэр өдрийнх
function PassionStrip({ studentId, view, day }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems([]);
    if (!studentId) return;
    instance({ method: "get", url: `/student/passion/${studentId}`, silent: true }).then((r) => {
      const out = [];
      (r.data?.programs || []).filter((p) => p.mine?.status === "confirmed").forEach((p) => {
        const s = p.sessions.find((x) => x.id === p.mine.sessionId);
        (s?.slots || []).forEach((t) => out.push({ key: `${p.id}-${t.day}-${t.startTime}`, p, day: t.day, start: t.startTime.slice(0, 5), end: t.endTime.slice(0, 5) }));
      });
      setItems(out.sort((a, b) => a.day - b.day || a.start.localeCompare(b.start)));
    }).catch(() => {});
  }, [studentId]);
  const list = view === "day" ? items.filter((x) => x.day === day) : items;
  if (!items.length) return null;
  return (
    <section className="flex flex-col gap-2">
      <div className="eyebrow">Passion Program</div>
      {!list.length ? <div className="text-sm" style={{ color: "var(--tj-violet-500)" }}>Энэ өдөр Passion хөтөлбөр алга</div> : (
        <div className="grid gap-2 md:grid-cols-2">
          {list.map((x) => (
            <div key={x.key} className="flex items-center gap-3 rounded-2xl p-2.5 text-white" style={{ background: "#5c1090" }}>
              <span className="h-12 w-12 rounded-xl overflow-hidden shrink-0 bg-[#2a1245]">{x.p.coverUrl && <img src={assetUrl(x.p.coverUrl)} alt="" className="h-full w-full object-cover" />}</span>
              <span className="flex-1 min-w-0">
                <span className="block font-extrabold uppercase text-[14px] leading-tight truncate">{x.p.name}</span>
                <span className="block text-xs text-white/80 truncate">{x.p.location || ""}</span>
              </span>
              <span className="text-right shrink-0">
                {view !== "day" && <span className="block text-xs text-white/80">{DAY_FULL[x.day]}</span>}
                <span className="block text-[13px] font-bold" style={{ color: "#f2cd30" }}>{x.start}–{x.end}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

const sectionsOf = (s) => s.groups.filter((g) => g.type === "Үндсэн").map((g) => g.code);

export default function Timetable() {
  const [data, setData] = useState(null);
  const [child, setChild] = useState(0);
  const [view, setView] = useState(window.innerWidth < 760 ? "day" : "week");
  // Утас (нарийн дэлгэц) бол долоо хоногийг дэлгэцэнд багтах жижиг хэлбэрээр
  const [compact, setCompact] = useState(window.innerWidth < 760);
  useEffect(() => {
    const on = () => setCompact(window.innerWidth < 760);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  const dow = new Date().getDay();
  const [day, setDay] = useState(dow >= 1 && dow <= 5 ? dow : 1);

  useEffect(() => {
    instance({ method: "get", url: "/student/timetable" }).then((r) => setData(r.data)).catch(() => setData({ children: [] }));
  }, []);

  const kids = data?.children || [];
  const c = kids[child];
  // Ангийн өрөө = энгийн хичээлд хамгийн их хэрэглэгдсэн танхим
  const homeRoom = useMemo(() => {
    if (!c) return "";
    const m = {};
    c.slots.filter((s) => s.kind === "core" && s.room && sectionsOf(s).includes(c.section)).forEach((s) => { m[s.room] = (m[s.room] || 0) + 1; });
    return Object.entries(m).sort((a, b) => b[1] - a[1])[0]?.[0] || "";
  }, [c]);

  if (!data) return <div className="py-16 flex justify-center"><Spin /></div>;
  const ctx = { view: "section", code: c?.section };

  return (
    <div className={`tas-tt pt-3 flex flex-col gap-5${compact ? " is-compact" : ""}`}>
      <div>
        <div className="eyebrow eyebrow--teal">{c?.elementary ? "Бага анги" : data.timetable ? data.timetable.name : "Томүжин"}</div>
        <div className="class-title" style={{ fontSize: 28 }}>Хичээлийн хуваарь.</div>
      </div>

      {kids.length > 1 && (
        <div className="class-picker" style={{ justifyContent: "flex-start", marginTop: 0 }}>
          {kids.map((k, i) => (
            <button key={k.student.id} type="button" className="chip" aria-pressed={i === child} onClick={() => setChild(i)}>{k.student.firstName}</button>
          ))}
        </div>
      )}

      {c?.elementary ? (
        // Бага анги — өөрийн цагтай хуваарь
        <>
          <div className="toolbar">
            <div className="class-info">
              <div className="class-title">{`${c.student.grade}-р анги`}</div>
              <div className="home-room">{c.student.lastName?.charAt(0)}. {c.student.firstName} · {c.elementary.timetable.name}</div>
            </div>
            <div className="segmented" role="tablist">
              {[["week", "Долоо хоног"], ["day", "Өдрөөр"]].map(([v, l]) => (
                <button key={v} type="button" role="tab" aria-selected={view === v} onClick={() => setView(v)}>{l}</button>
              ))}
            </div>
          </div>
          {view === "week" ? <ElementaryWeek slots={c.elementary.slots} /> : <ElementaryDay slots={c.elementary.slots} day={day} onDay={setDay} />}
        </>
      ) : !data.timetable || !c ? (
        <div className="py-10 text-center" style={{ color: "var(--tj-violet-500)" }}>Хуваарь хараахан нийтлэгдээгүй байна</div>
      ) : (
        <>
          <div className="toolbar">
            <div className="class-info">
              <div className="class-title">{c.section || `${c.student.grade}-р анги`}</div>
              <div className="home-room">
                {c.student.lastName?.charAt(0)}. {c.student.firstName}
                {homeRoom && <> · Ангийн өрөө: <strong>{homeRoom}</strong></>}
              </div>
            </div>
            <div className="segmented" role="tablist">
              {[["week", "Долоо хоног"], ["day", "Өдрөөр"]].map(([v, l]) => (
                <button key={v} type="button" role="tab" aria-selected={view === v} onClick={() => setView(v)}>{l}</button>
              ))}
            </div>
          </div>
          <Legend />
          {!c.slots.length ? <div className="py-10 text-center" style={{ color: "var(--tj-violet-500)" }}>Хуваарьт цаг алга</div>
            : view === "week" ? <WeekGrid slots={c.slots} meta={data} ctx={ctx} compact={compact} />
            : <DayList slots={c.slots} meta={data} ctx={ctx} day={day} onDay={setDay} />}
          <PassionStrip studentId={c.student.id} view={view} day={day} />
        </>
      )}
    </div>
  );
}
